import React from 'react';

import EmetCertificationFinish from './table/EmetCertificationFinish';

const index = (props) => (
    <EmetCertificationFinish />
);

export default index;